<template>
    <div class="header-wrapper">
        <div class="header-section draft-section">
            <div class="action-column">
                <button class="action-btn white-btn" @click="handleStatusIconClick">
                    {{ $trans("web_profile.show_draft") || 'Show draft' }}
                </button>
                <div class="date-info">
                    {{ $trans("web_profile.last_saved_on") || 'Last saved on:' }}<br>
                    {{ lastSaved || '-' }}
                </div>
            </div>
        </div>

        <div class="header-section publish-section">
            <div class="publish-left">
                <div class="action-column" v-if="lastPublished">
                    <button class="action-btn white-btn" @click="openLastPublishedLink">
                        {{ $trans("web_profile.show_online_profile") || 'Show online profile' }}
                    </button>
                    <div class="date-info">
                        {{ $trans("web_profile.last_published_on") || 'Last published on:' }}<br>
                        {{ lastPublished }}
                    </div>
                </div>
            </div>

            <div class="publish-right">
                <div class="action-column">
                    <button class="action-btn blue-btn" @click="openSubmitModal">
                        {{ $trans("web_profile.submit_draft") || 'Submit draft' }}
                    </button>
                    <div class="date-info">
                        {{ $trans("web_profile.last_submitted_on") || 'Last submitted on:' }}<br>
                        {{ lastSubmitted || '-' }}
                    </div>
                </div>
            </div>
        </div>

        <SubmitWebProfileModal
            v-model="isSubmitModalOpen"
            :user-group="profile?.group || 'DI'"
            :user-lang="profile?.lang || 'de'"
            @confirm="handleSubmitConfirm"
        />
    </div>
</template>

<script>
import { useWebProfileStore } from "@/stores/WebProfileStore";
import { mapState, mapActions } from "pinia";
import SubmitWebProfileModal from "./Modals/SubmitWebProfileModal.vue";

export default {
    name: "WebProfileHeader",
    components: {
        SubmitWebProfileModal
    },
    data() {
        return {
            isSubmitModalOpen: false,
        };
    },
    computed: {
        ...mapState(useWebProfileStore, [
            "profile",
            "lastPublished",
            "lastSaved",
            "lastSubmitted",
            "hasConsentedToPublish",
            "status",
            "path",
            "webProfile"
        ])
    },
    methods: {
        ...mapActions(useWebProfileStore, ["previewWebProfile", "submitWebProfile"]),
        openLastPublishedLink() {
            if (this.path) {
                window.open(this.path, "_blank");
            }
        },
        async handleStatusIconClick() {
            const redirectUrl = await this.previewWebProfile(this.profile.id);
            if (redirectUrl) window.open(redirectUrl, "_blank");
        },
        openSubmitModal() {
            if (!this.webProfile?.area_of_expertise_name || !this.webProfile?.verticals_name) {
                this.$message.error(
                    this.$trans("web_profile.select_aoe_and_branches") ||
                    "Please select Area of Expertise and Industry Sector before submitting."
                );
                return;
            }

            if (!this.profile?.claim) { 
                this.$message.error(
                    this.$trans("web_profile.claim_is_empty") || 
                    "Please generate a headline before submitting."
                );
                return;
            }

            if (!this.profile?.summary) {
                this.$message.error(
                    this.$trans("web_profile.summary_is_empty") ||
                    "Please generate a summary before submitting."
                );
                return;
            }

            if (this.hasConsentedToPublish) {
                this.handleSubmitConfirm();
                return;
            }

            this.isSubmitModalOpen = true;
        },
        async handleSubmitConfirm() {
            const success = await this.submitWebProfile();
            if (success) {
                this.$message.success(
                    this.$trans("web_profile.web_profile_submitted_successfully")
                );
            } else {
                 this.$message.error(
                    this.$trans("global.something_went_wrong") || "Something went wrong"
                );
            }
        }
    },
};
</script>

<style scoped>
.header-wrapper {
    display: flex;
    gap: 15px;
    margin-bottom: 30px;
}

.header-section {
    background-color: #d2e1e5;
    padding: 20px;
    border-radius: 8px;
    display: flex;
}

.draft-section {
    flex: 0 0 auto;
}

.publish-section {
    flex: 1;
    display: flex;
    justify-content: space-between;
}

.publish-left {
    display: flex;
}

.publish-right {
    display: flex;
    justify-content: flex-end;
}

.action-column {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 220px;
    max-width: 320px;
}

.action-btn {
    width: 100%;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.2s ease, color 0.2s ease;
    border-radius: 2px;
}

.white-btn {
    background-color: #ffffff;
    color: #333;
}

.white-btn:hover {
    background-color: #41abc4;
    color: #ffffff;
}

.blue-btn {
    background-color: #41abc4;
    color: #ffffff;
}

.blue-btn:hover {
    background-color: #3693a9;
}

.date-info {
    font-size: 0.85rem;
    color: #333;
    line-height: 1.4;
}
</style>